/** Browser-safe image types, including MIME names used by older Mantis installations. */
const IMAGE_TYPES: Record<string, string> = {
  'image/png': 'image/png',
  'image/x-png': 'image/png',
  'image/jpeg': 'image/jpeg',
  'image/jpg': 'image/jpeg',
  'image/pjpeg': 'image/jpeg',
  'image/gif': 'image/gif',
  'image/webp': 'image/webp',
  'image/bmp': 'image/bmp',
  'image/x-bmp': 'image/bmp',
  'image/x-ms-bmp': 'image/bmp',
  'image/avif': 'image/avif',
};

export function imageContentType(fileType: string): string | null {
  const type = fileType.split(';', 1)[0].trim().toLowerCase();
  return Object.hasOwn(IMAGE_TYPES, type) ? IMAGE_TYPES[type] : null;
}

const VIDEO_TYPES: Record<string, string> = {
  'video/mp4': 'video/mp4',
  'video/x-m4v': 'video/mp4',
  'application/mp4': 'video/mp4',
  'video/webm': 'video/webm',
  'video/ogg': 'video/ogg',
  'video/quicktime': 'video/quicktime',
};

export function videoContentType(fileType: string, filename = ''): string | null {
  const type = fileType.split(';', 1)[0].trim().toLowerCase();
  if (Object.hasOwn(VIDEO_TYPES, type)) return VIDEO_TYPES[type];
  // Older Mantis uploads may have only a generic MIME type. Never reinterpret HTML/SVG as video.
  if (type !== '' && type !== 'application/octet-stream') return null;
  const extension = filename.split('.').pop()?.toLowerCase();
  return extension === 'mp4' || extension === 'm4v' ? 'video/mp4'
    : extension === 'webm' ? 'video/webm' : extension === 'ogv' ? 'video/ogg'
    : extension === 'mov' ? 'video/quicktime' : null;
}

/** SVG and HTML stay downloads; inline media types are explicitly allowlisted. */
export function inlineContentType(fileType: string, filename = ''): string | null {
  const type = fileType.split(';', 1)[0].trim().toLowerCase();
  return imageContentType(type) ?? videoContentType(type, filename) ?? (type === 'application/pdf' || type === 'text/plain' ? type : null);
}
